import { TextFilterProps } from '@progress/kendo-react-data-tools'
import { useAppSelector } from 'store'

import { SelectFilter } from '../SelectFilter'

export const TradingAccountStatusFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const tradingAccountStatus = useAppSelector((state) => state.tradingAccounts.tradingAccountStatus)

  const data = tradingAccountStatus.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return <SelectFilter filter={filter} onFilterChange={onFilterChange} data={data} />
}
